export const   formula_zh ={
    formula:{
        name:"名称",
        updateTime:"更新时间",
        updateInterval:"更新间隔",
        queryTime:"查询时间",
        state:"状态",
        newData:"最新数据",
    }
}

export const   formula_en ={
      formula:{
        name:"name",
        updateTime:"Update time",
        updateInterval:"update interval",
        queryTime:"Query time",
        state:"state",
        newData:"Latest data",
    }
}